import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

import { So5FixtureEvent } from '@sorare/core/src/__generated__/globalTypes';
import { ContentWithStickyHeader } from '@sorare/core/src/atoms/layout/ContentWithStickyHeader';
import { FullWidthContainer } from '@sorare/core/src/atoms/layout/FullWidthContainer';
import { Tab, TabBar } from '@sorare/core/src/atoms/navigation/TabBar';
import {
  ANY_SPORT_PLAY_EVENTTYPE_FIXTURE,
  ANY_SPORT_PLAY_EVENTTYPE_FIXTURE_REWARDS,
} from '@sorare/core/src/constants/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useFeatureFlags } from '@sorare/core/src/hooks/useFeatureFlags';
import { glossary } from '@sorare/core/src/lib/glossary';

type Props = {
  so5FixtureSlug: string;
  eventType: So5FixtureEvent;
  children: ReactNode;
};

export const FixtureTabLayout = ({
  so5FixtureSlug,
  eventType,
  children,
}: Props) => {
  const {
    flags: { useNewAdvancedLobby = false },
  } = useFeatureFlags();
  const { generateSportContextPath } = useSportContext();
  if (!useNewAdvancedLobby) {
    return children;
  }
  return (
    <ContentWithStickyHeader
      header={
        <FullWidthContainer.NoPadding>
          <TabBar variant="flat" fullWidth>
            <Tab
              to={generateSportContextPath(ANY_SPORT_PLAY_EVENTTYPE_FIXTURE, {
                params: {
                  fixture: so5FixtureSlug,
                  eventType: eventType.toLowerCase(),
                },
              })}
            >
              <FormattedMessage {...glossary.lineups} />
            </Tab>
            <Tab
              to={generateSportContextPath(
                ANY_SPORT_PLAY_EVENTTYPE_FIXTURE_REWARDS,
                {
                  params: {
                    fixture: so5FixtureSlug,
                    eventType: eventType.toLowerCase(),
                  },
                }
              )}
            >
              <FormattedMessage {...glossary.rewards} />
            </Tab>
          </TabBar>
        </FullWidthContainer.NoPadding>
      }
    >
      {children}
    </ContentWithStickyHeader>
  );
};
